// extracted by mini-css-extract-plugin
export default {"list":"language-change_list__d9NsN","listItem":"language-change_listItem__fGXWi","btn":"language-change_btn__Mak36","active":"language-change_active__OBiSI"};